//简述你的方法说函数作用，以及参数作用 示例： columnSetup(changearr,initarr) 基于element表格设置列   changearr：多选框选中的数组   initarr：表头数组
import { Decimal } from 'decimal.js';
var baseAPI={
	isCarNum(num){
	  let flag=false
	  var regC =/^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼][A-Z]([A-HJ-NP-Z]([A-HJ-NP-Z0-9]{5})|([A-HJ-NP-Z0-9]{5}[A-HJ-NP-Z])))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领])|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{2}([0-9]|[A-Z]){5}))$/;
	  if (regC.test(num)){
	    flag=true
	  }
	  console.log(flag)
	  return flag
	},
    columnSetup(changearr,initarr){//基于element表格设置列   changearr：多选框选中的数组   initarr：表头数组
        let newarr=[]
        for (let i = 0; i < initarr.length; i++) {
            for (let j = 0; j < changearr.length; j++) {
                let lisitem=initarr[i]
                if(lisitem.label==changearr[j]){
                    newarr.push(lisitem)
                }
            }
        }
        return newarr
    },
	formattingTime(time){//时间选择器，时间格式化.数据格式进仅限于示例：['2020-10-11T16:00:00','2020-10-11T16:00:00'...]
		var fattime=[]
		for(let i=0;i<time.length;i++){
			var timearr=time[i].split('T')
			fattime.push(timearr[0])
		}
		return fattime
	},
	dateFtt(fmt, date) { //fmt：'yyyy-MM-dd'   date：毫秒值 
		var o = {
			"M+": date.getMonth() + 1, //月份   
			"d+": date.getDate(), //日   
		};
		if(/(y+)/.test(fmt))
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		for(var k in o)
		if(new RegExp("(" + k + ")").test(fmt))
		fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	},
    dateHfm(fmt, time){//fmt：'yyyy-MM-dd hh:mm:ss'   date：毫秒值 
		var o = {
					"M+": time.getMonth() + 1, //月份   
					"d+": time.getDate(),
					"h+": time.getHours(),                   //小时   
					"m+": time.getMinutes(),                 //分   
					"s+": time.getSeconds(),                 //秒   
					"q+": Math.floor((time.getMonth() + 3) / 3), //季度   
					"S": time.getMilliseconds()  

				};
				var fmt='yyyy-MM-dd hh:mm:ss';
				if(/(y+)/.test(fmt)){
					 fmt = fmt.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
				}
				for(var k in o){
					if (new RegExp(`(${k})`).test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		         }

				} 
				return fmt
	},
	yesterdayFtt(){//格式化昨天时间
		var time=''
		var date=new Date()
		var y=date.getFullYear()
		var m=date.getMonth()+1
		var d=date.getDate()
		if(d==1){
			m-=1
			if(m==1||m==3||m==5||m==7||m==8||m==10||m==12){
				d=31
			}else{
				if(m==2){
					if(y % 4 == 0 && y % 100 != 0 || y % 400 == 0){
						d=29
					}else{
						d=28
					}
				}else{
					m=30
				}
			}
		}else{
			d-=1
		}
		m=m<10?'0'+m:m
		d=d<10?'0'+d:d
		return `${y}-${m}-${d}`
	},
	querSoleList(solelist,solepath){//获取当前页权限对象
		var finallist=''
		solelist.forEach(resitem=>{
			if(resitem.PERTB001CA03==solepath){
				finallist=resitem
			}
		})
		return finallist.childMenus
	},
	/*负数变正数*/
	negativeChange (args){
		if (args < 0) {
		args = args * -1;
		}else{
			args=args;
		}
		return args;
	},
	/*保留两位的小数*/
	twoDecimal(value){
		value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
		value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
		value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
		if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
			value = parseFloat(value);
			
		}
		return value;
	},
	axiosstatusMsg(status){//参数为错误返回状态catch((err) => {axiosstatusMsg(error)})
		var msgStr=''
		if (status && status.response) {
		    switch (status.response.status) {
		        case 400:
		            msgStr = '错误请求';
		            break;
		        case 401:
		            msgStr = '未授权，请重新登录';
		            break;
		        case 403:
		            msgStr = '拒绝访问';
		            break;
		        case 404:
		            msgStr = '请求错误,未找到该资源';
		            break;
		        case 405:
		            msgStr = '请求方法未允许';
		            break;
		        case 408:
		            msgStr = '请求超时';
		            break;
		        case 500:
		            msgStr = '服务器端出错';
		            break;
		        case 501:
		            msgStr = '网络未实现';
		            break;
		        case 502:
		            msgStr = '网络错误';
		            break;
		        case 503:
		            msgStr = '服务不可用';
		            break;
		        case 504:
		            msgStr = '网络超时';
		            break;
		        case 505:
		            msgStr = 'http版本不支持该请求';
		            break;
		        default:
		            msgStr = `连接错误${status.response.status}`;
		    }
		}
		return msgStr
	},
	calculate(num,numtype,numparseint){//金额计算
		if(num==0) return
		if(numparseint==0){
			//金额后小数舍去
			num=parseInt(num)
		}else if(numparseint==1){
			//金额后小数四舍五入取整
			num=Math.round(num)
		}else if(numparseint==2){
			//保留金额后两位小数
			num=Number(num.toFixed(2));
		}
		var money=parseInt(num%10);
		var numarr=num.toString().split('')
		var i=numarr.indexOf(".")
		if(numtype==0){
			//0保留个位不变
		}else if(numtype>0&&numtype<10){
			//1-9个位抹零 列5，五以上十位进一，个位抹零，五一下个位抹零
			if(money>=numtype) {
				var str=numarr.join('')
				if(i!='-1'){
					str=new Decimal(str).add(new Decimal(10))
					numarr=str.toString().split('')
					numarr[i-1]=0
				}else{
					str=new Decimal(str).add(new Decimal(10))
					numarr=str.toString().split('')
					numarr[numarr.length-1]=0
				}
			}else{
				if(i!='-1'){
					numarr[i-1]=0
				}else{
					numarr[numarr.length-1]=0
				}
			}
		}else if(numtype==10){
			//10个位抹零
			if(i!='-1'){
				numarr[i-1]=0
			}else{
				numarr[numarr.length-1]=0
			}
		}else if(numtype==11){
			//5以上收5,5以下舍去
			if(money<5) {
				if(i!='-1'){
					numarr[i-1]=0
				}else{
					numarr[numarr.length-1]=0
				}
			}
			if(money>=5) {
				if(i!='-1'){
					numarr[i-1]=5
				}else{
					numarr[numarr.length-1]=5
				}
			}
		}else if(numtype==12){
			//12是大于等于2000的个数舍去取到十位，小于2000的个位数如果大于等于5，个位取5，小于5的话个位舍去
			if(num>=2000) {
				if(i!='-1'){
					numarr[i-1]=0
				}else{
					numarr[numarr.length-1]=0
				}
			}
			if(num<2000){
				if(money<5) {
					if(i!='-1'){
						numarr[i-1]=0
					}else{
						numarr[numarr.length-1]=0
					}
				}
				if(money>5) {
					if(i!='-1'){
						numarr[i-1]=5
					}else{
						numarr[numarr.length-1]=5
					}
				}
			}
		}
		return num =numarr.join('')
	}
	
}
export default baseAPI